import { FC } from 'react';
import TagPill from './Tag';

interface TagPreviewProps {
  name: string;
  color: string;
  icon: string;
}

const TagPreview: FC<TagPreviewProps> = ({ name, color, icon }) => {
  return (
    <div className="flex w-full justify-center overflow-x-auto bg-[#FAFAFA] p-10">
      <TagPill tag={{ name, color, icon, id: '', isActive: true, priority: 0 }} textStyle="break-words" />
    </div>
  );
};

export default TagPreview;
